module.exports = __webpack_public_path__ + "img/console36.9ec019e4.jpg";